import { render, staticRenderFns } from "./Perfiles.vue?vue&type=template&id=1d8c0ad2&scoped=true"
import script from "./Perfiles.vue?vue&type=script&lang=js"
export * from "./Perfiles.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Perfiles.vue?vue&type=style&index=1&id=1d8c0ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c0ad2",
  null
  
)

export default component.exports